// extracted by mini-css-extract-plugin
export default {"host":"TagColumn_host__20aL9","tag":"TagColumn_tag__I7bGn"};